import { Link } from 'react-router-dom';
import { teamMembers, brandMilestones, faqItems } from '@/mocks/articles';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'AboutPage',
        name: '关于17吃瓜网 - 品牌故事',
        description: '17吃瓜网是中国领先的娱乐资讯平台，致力于为用户提供真实、及时、深度的娱乐八卦和网红爆料内容。',
        url: 'https://17chigua.com/about',
        isPartOf: { '@id': 'https://17chigua.com/#website' },
      },
      {
        '@type': 'Organization',
        name: '17吃瓜网',
        url: 'https://17chigua.com',
        description: '中国领先的娱乐资讯平台，汇集全网热门吃瓜爆料、网红黑料、明星塌房事件。',
        foundingDate: '2019',
        founders: [{ '@type': 'Person', name: '张明远' }],
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, item: { '@id': 'https://17chigua.com/', name: '首页' } },
          { '@type': 'ListItem', position: 2, item: { '@id': 'https://17chigua.com/about', name: '关于我们' } },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqItems.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <SEOHead
        title="关于我们 | 17吃瓜网 - 品牌故事与联系方式"
        description="了解17吃瓜网的品牌故事、发展历程、团队介绍及联系方式。17吃瓜网是中国领先的娱乐资讯平台，致力于为用户提供真实、及时、深度的娱乐内容。"
        keywords="17吃瓜网,关于我们,品牌故事,联系方式,团队介绍"
        canonicalUrl="https://17chigua.com/about"
      />
      <Navbar />

      <main className="pt-16">
        {/* Breadcrumb */}
        <div className="px-4 md:px-6 py-4 border-b border-background-200 bg-background-50">
          <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
        </div>

        {/* Brand Story - 50/50 Split */}
        <section className="bg-background-50">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-1/2 p-6 md:p-10 flex items-center">
              <div className="rounded-3xl overflow-hidden w-full h-[350px] md:h-[450px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20editorial%20office%20workspace%20with%20creative%20team%20collaborating%2C%20warm%20coral%20accent%20wall%2C%20dark%20teal%20furniture%20details%2C%20professional%20yet%20relaxed%20atmosphere%2C%20natural%20light%20streaming%20through%20large%20windows%2C%20clean%20minimal%20design%2C%20photography%20magazine%20aesthetic%2C%20no%20faces%20visible%20only%20silhouettes&width=1200&height=900&seq=about-brand-team&orientation=landscape"
                  alt="17吃瓜网团队"
                  title="17吃瓜网 - 我们的团队"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="lg:w-1/2 p-6 md:p-10 flex flex-col justify-center">
              <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-label rounded-full w-fit">
                品牌故事
              </span>
              <h1 className="mt-3 text-2xl md:text-4xl font-heading font-black text-foreground-950 leading-tight">
                还原真相
                <br />
                传递价值
              </h1>
              <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
                17吃瓜网创立于2019年，是中国领先的娱乐资讯平台。我们秉持"还原真相，传递价值"的理念，致力于为用户提供真实、及时、深度的娱乐八卦、网红爆料和明星动态。
              </p>
              <p className="mt-3 text-sm md:text-base text-foreground-500 leading-relaxed">
                我们拥有一支经验丰富的调查记者团队和专业的编辑审核流程，确保每一条资讯的真实性和可靠性。经过多年的发展，17吃瓜网已成为华语互联网最具影响力的娱乐资讯平台之一，日均服务超过千万用户。
              </p>
              <Link
                to="#subscribe-area"
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 border border-foreground-200 text-foreground-700 font-label text-sm rounded-lg hover:border-primary-400 hover:text-primary-600 transition-colors duration-200 w-fit whitespace-nowrap cursor-pointer"
              >
                加入我们 <i className="ri-arrow-right-up-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-[1000px] mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-3 py-1 border border-background-300 text-foreground-600 text-xs font-label rounded-full">
                发展历程
              </span>
              <h2 className="mt-3 text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                品牌之路
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                从创立至今，我们一直在成长
              </p>
            </div>

            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-300 md:-translate-x-1/2"></div>

              <div className="flex flex-col gap-8">
                {brandMilestones.map((milestone, index) => (
                  <div
                    key={milestone.year}
                    className={`relative flex flex-col md:flex-row gap-4 md:gap-10 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className="md:w-1/2 flex items-start gap-4 pl-12 md:pl-0 md:justify-end">
                      <div className={`md:text-right ${index % 2 === 1 ? 'md:text-left md:pl-12' : 'md:pr-12'}`}>
                        <span className="inline-block px-3 py-1 bg-accent-500 text-background-50 text-xs font-label rounded-full mb-2">
                          {milestone.year}
                        </span>
                        <h3 className="text-lg font-heading font-bold text-foreground-950">
                          {milestone.title}
                        </h3>
                        <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">
                          {milestone.description}
                        </p>
                      </div>
                    </div>
                    <div className="absolute left-4 md:left-1/2 top-2 w-3 h-3 rounded-full bg-primary-500 md:-translate-x-1/2 z-10"></div>
                    <div className="md:w-1/2 hidden md:block"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-[1100px] mx-auto">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 border border-background-300 text-foreground-600 text-xs font-label rounded-full">
                核心团队
              </span>
              <h2 className="mt-3 text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                我们的团队
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                一群热爱真相的媒体人
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center group">
                <div className="rounded-2xl overflow-hidden h-[260px] md:h-[300px] mb-4 bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20journalist%20in%20his%2040s%2C%20confident%20expression%2C%20wearing%20casual%20blazer%2C%20warm%20coral%20background%20accent%2C%20editorial%20portrait%20photography%2C%20clean%20minimal%20composition%2C%20natural%20lighting%2C%20approachable%20yet%20authoritative%20look&width=600&height=750&seq=team-1&orientation=portrait"
                    alt="张明远"
                    title="张明远 - 创始人 & 总编"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950">张明远</h3>
                <p className="text-xs text-primary-500 font-label mt-1">创始人 &amp; 总编</p>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed px-2">前主流媒体资深调查记者，拥有15年娱乐新闻报道经验，曾多次获得新闻行业大奖。</p>
              </div>
              <div className="text-center group">
                <div className="rounded-2xl overflow-hidden h-[260px] md:h-[300px] mb-4 bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20editor%20in%20her%2030s%2C%20sharp%20intelligent%20look%2C%20modern%20office%20attire%2C%20warm%20background%20with%20teal%20accents%2C%20editorial%20portrait%20photography%2C%20clean%20composition%2C%20confident%20and%20approachable&width=600&height=750&seq=team-2&orientation=portrait"
                    alt="李思涵"
                    title="李思涵 - 执行主编"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950">李思涵</h3>
                <p className="text-xs text-primary-500 font-label mt-1">执行主编</p>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed px-2">深耕娱乐产业报道10年，曾在多家头部娱乐媒体担任要职，拥有丰富的人脉资源和行业洞察力。</p>
              </div>
              <div className="text-center group">
                <div className="rounded-2xl overflow-hidden h-[260px] md:h-[300px] mb-4 bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=Chinese%20male%20investigative%20journalist%20in%20his%2030s%2C%20determined%20expression%2C%20casual%20professional%20style%2C%20dark%20teal%20background%2C%20editorial%20portrait%20photography%2C%20cinematic%20lighting%2C%20serious%20yet%20approachable%20mood&width=600&height=750&seq=team-3&orientation=portrait"
                    alt="王浩然"
                    title="王浩然 - 首席调查记者"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950">王浩然</h3>
                <p className="text-xs text-primary-500 font-label mt-1">首席调查记者</p>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed px-2">擅长深度调查报道，曾暗访曝光多起行业黑幕，作品多次引发社会广泛关注和讨论。</p>
              </div>
              <div className="text-center group">
                <div className="rounded-2xl overflow-hidden h-[260px] md:h-[300px] mb-4 bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=Chinese%20female%20video%20content%20director%20in%20her%2030s%2C%20creative%20energetic%20look%2C%20modern%20fashion%20style%2C%20coral%20pink%20warm%20background%2C%20editorial%20portrait%20photography%2C%20natural%20soft%20lighting%2C%20professional%20yet%20friendly&width=600&height=750&seq=team-4&orientation=portrait"
                    alt="陈雨萱"
                    title="陈雨萱 - 视频内容总监"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950">陈雨萱</h3>
                <p className="text-xs text-primary-500 font-label mt-1">视频内容总监</p>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed px-2">前头部短视频平台内容运营负责人，对视频内容策划和传播有独到见解和丰富经验。</p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-[800px] mx-auto">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 border border-background-300 text-foreground-600 text-xs font-label rounded-full">
                常见问题
              </span>
              <h2 className="mt-3 text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                你关心的都在这里
              </h2>
            </div>

            <div className="flex flex-col gap-3">
              {faqItems.map((faq, index) => (
                <details key={index} className="group rounded-xl bg-background-50 border border-background-200 overflow-hidden">
                  <summary className="px-6 py-4 flex items-center justify-between cursor-pointer font-label text-sm font-medium text-foreground-800 list-none">
                    {faq.question}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 w-5 h-5 flex items-center justify-center"></i>
                  </summary>
                  <div className="px-6 pb-4 text-sm text-foreground-500 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section id="contact" className="flex flex-col lg:flex-row">
          <div className="lg:w-1/2 relative h-[350px] md:h-[450px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20beige%20and%20coral%20abstract%20composition%2C%20soft%20flowing%20geometric%20shapes%2C%20dreamy%20atmospheric%20lighting%2C%20elegant%20editorial%20background%2C%20clean%20minimal%20design%2C%20sophisticated%20texture%2C%20professional%20yet%20approachable%20mood%2C%20no%20text%20no%20people&width=1200&height=800&seq=about-cta-contact&orientation=landscape"
              alt="联系17吃瓜网"
              title="联系我们"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            <div className="absolute bottom-8 left-8 right-8">
              <span className="text-background-50/60 text-xs font-label uppercase tracking-wider">
                期待合作
              </span>
              <p className="mt-2 text-3xl md:text-5xl font-heading font-black text-background-50 leading-tight">
                联系
                <br />
                我们
                <br />
                一起搞大新闻
              </p>
            </div>
          </div>

          <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center py-14 md:py-20 px-6 md:px-16 text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              商务合作
              <br />
              与投稿爆料
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-md leading-relaxed">
              如果您有爆料线索、商务合作需求，或者想加入我们的创作团队，请随时与我们取得联系。
            </p>

            <div className="mt-8 flex flex-col gap-3 w-full max-w-md">
              <div className="flex items-center gap-3 p-4 bg-background-100 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                  <i className="ri-mail-line text-lg text-primary-600"></i>
                </div>
                <div className="text-left">
                  <p className="text-xs text-foreground-400 font-label">投稿邮箱</p>
                  <p className="text-sm font-label text-foreground-800">tips@17chigua.com</p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-background-100 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                  <i className="ri-briefcase-line text-lg text-accent-600"></i>
                </div>
                <div className="text-left">
                  <p className="text-xs text-foreground-400 font-label">商务合作</p>
                  <p className="text-sm font-label text-foreground-800">biz@17chigua.com</p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-background-100 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-300 flex-shrink-0">
                  <i className="ri-user-add-line text-lg text-secondary-700"></i>
                </div>
                <div className="text-left">
                  <p className="text-xs text-foreground-400 font-label">招聘邮箱</p>
                  <p className="text-sm font-label text-foreground-800">hr@17chigua.com</p>
                </div>
              </div>
            </div>

            <p className="mt-8 text-xs text-foreground-400">
              我们会在1-3个工作日内回复您的邮件
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}